import { IModuleProps } from '../../core/utils/modules';

export default {
    name: 'pichlerluft',
} as IModuleProps;
